export const MODULE_ACTIONS_ENUM = {
  AJUDA: {
    id: 'AJUDA',
    descricao: 'Ajuda - Acessou Ajuda',
  },
  FAZENDAS_NOVO: {
    id: 'FAZENDAS_NOVO',
    descricao: 'Fazendas - Acessou Página de Criação',
  },
  FAZENDAS_CRIAR: {
    id: 'FAZENDAS_CRIAR',
    descricao: 'Fazendas - Criou uma fazenda',
  },
  FAZENDAS_EDITAR: {
    id: 'FAZENDAS_EDITAR',
    descricao: 'Fazendas - Editou uma fazenda',
  },
  FAZENDAS_EXCLUIR: {
    id: 'FAZENDAS_EXCLUIR',
    descricao: 'Fazendas - Excluiu uma fazenda',
  },
  FAZENDAS_ENTRAR: {
    id: 'FAZENDAS_ENTRAR',
    descricao: 'Fazendas - Acessou fazenda',
  },
  CADASTRO_PERMISSAO_ACESSO_NOVO: {
    id: 'CADASTRO_PERMISSAO_ACESSO_NOVO',
    descricao: 'Cadastros - Permissão de Acesso - Acessou Página de Criação',
  },
  CULTURA_NOVO: {
    id: 'CULTURA_NOVO',
    descricao: 'Módulo Geral - Cultura - Acessou Página de Criação',
  },
  CULTURA_NAVEGAR_PARA_EDICAO: {
    id: 'CULTURA_NAVEGAR_PARA_EDICAO',
    descricao: 'Módulo Geral - Cultura - Acessou Tela de Edição',
  },
  CULTURA_EDITAR: {
    id: 'CULTURA_EDITAR',
    descricao: 'Módulo Geral - Cultura - Editou Registro',
  },
  CULTURA_EXCLUIR: {
    id: 'CULTURA_EXCLUIR',
    descricao: 'Módulo Geral - Cultura - Excluiu Registro',
  },
  CULTURA_CRIAR: {
    id: 'CULTURA_CRIAR',
    descricao: 'Módulo Geral - Cultura - Criou Registro',
  },
  PRODUTOS_AGRICOLA_NOVO: {
    id: 'PRODUTOS_AGRICOLA_NOVO',
    descricao: 'Módulo Geral - Produtos Agrícola - Acessou Página de Criação',
  },
  PRODUTOS_AGRICOLA_NAVEGAR_PARA_EDICAO: {
    id: 'PRODUTOS_AGRICOLA_NAVEGAR_PARA_EDICAO',
    descricao: 'Módulo Geral - Produtos Agrícola - Acessou Tela de Edição',
  },
  PRODUTOS_AGRICOLA_EDITAR: {
    id: 'PRODUTOS_AGRICOLA_EDITAR',
    descricao: 'Módulo Geral - Produtos Agrícola - Editou Registro',
  },
  PRODUTOS_AGRICOLA_EXCLUIR: {
    id: 'PRODUTOS_AGRICOLA_EXCLUIR',
    descricao: 'Módulo Geral - Produtos Agrícola - Excluiu Registro',
  },
  PRODUTOS_AGRICOLA_CRIAR: {
    id: 'PRODUTOS_AGRICOLA_CRIAR',
    descricao: 'Módulo Geral - Produtos Agrícola - Criou Registro',
  },
  TALHAO_NOVO: {
    id: 'TALHAO_NOVO',
    descricao: 'Módulo Geral - Talhão - Acessou Página de Criação',
  },
  TALHAO_NAVEGAR_PARA_EDICAO: {
    id: 'TALHAO_NAVEGAR_PARA_EDICAO',
    descricao: 'Módulo Geral - Talhão - Acessou Tela de Edição',
  },
  TALHAO_EDITAR: {
    id: 'TALHAO_EDITAR',
    descricao: 'Módulo Geral - Talhão - Editou Registro',
  },
  TALHAO_EXCLUIR: {
    id: 'TALHAO_EXCLUIR',
    descricao: 'Módulo Geral - Talhão - Excluiu Registro',
  },
  TALHAO_CRIAR: {
    id: 'TALHAO_CRIAR',
    descricao: 'Módulo Geral - Talhão - Criou Registro',
  },
  SAFRA_NOVO: {
    id: 'SAFRA_NOVO',
    descricao: 'Módulo Geral - Safra - Acessou Página de Criação',
  },
  SAFRA_NAVEGAR_PARA_EDICAO: {
    id: 'SAFRA_NAVEGAR_PARA_EDICAO',
    descricao: 'Módulo Geral - Safra - Acessou Tela de Edição',
  },
  SAFRA_EDITAR: {
    id: 'SAFRA_EDITAR',
    descricao: 'Módulo Geral - Safra - Editou Registro',
  },
  SAFRA_EXCLUIR: {
    id: 'SAFRA_EXCLUIR',
    descricao: 'Módulo Geral - Safra - Excluiu Registro',
  },
  SAFRA_CRIAR: {
    id: 'SAFRA_CRIAR',
    descricao: 'Módulo Geral - Safra - Criou Registro',
  },
  INSUMOS_AGRICOLA_NOVO: {
    id: 'INSUMOS_AGRICOLA_NOVO',
    descricao: 'Módulo Geral - Insumos Agrícola - Acessou Página de Criação',
  },
  INSUMOS_AGRICOLA_NAVEGAR_PARA_EDICAO: {
    id: 'INSUMOS_AGRICOLA_NAVEGAR_PARA_EDICAO',
    descricao: 'Módulo Geral - Insumos Agrícola - Acessou Tela de Edição',
  },
  INSUMOS_AGRICOLA_EDITAR: {
    id: 'INSUMOS_AGRICOLA_EDITAR',
    descricao: 'Módulo Geral - Insumos Agrícola - Editou Registro',
  },
  INSUMOS_AGRICOLA_EXCLUIR: {
    id: 'INSUMOS_AGRICOLA_EXCLUIR',
    descricao: 'Módulo Geral - Insumos Agrícola - Excluiu Registro',
  },
  INSUMOS_AGRICOLA_CRIAR: {
    id: 'INSUMOS_AGRICOLA_CRIAR',
    descricao: 'Módulo Geral - Insumos Agrícola - Criou Registro',
  },
  INSUMOS_AGRICOLA_FILTRAR: {
    id: 'INSUMOS_AGRICOLA_FILTRAR',
    descricao: 'Módulo Geral - Insumos Agrícola - Filtrou registros',
  },
  PROCEDIMENTO_AGRICOLA_NOVO: {
    id: 'PROCEDIMENTO_AGRICOLA_NOVO',
    descricao:
      'Módulo Geral - Procedimento Agrícola - Acessou Página de Criação',
  },
  PROCEDIMENTO_AGRICOLA_NAVEGAR_PARA_EDICAO: {
    id: 'PROCEDIMENTO_AGRICOLA_NAVEGAR_PARA_EDICAO',
    descricao: 'Módulo Geral - Procedimento Agrícola - Acessou Tela de Edição',
  },
  PROCEDIMENTO_AGRICOLA_EDITAR: {
    id: 'PROCEDIMENTO_AGRICOLA_EDITAR',
    descricao: 'Módulo Geral - Procedimento Agrícola - Editou Registro',
  },
  PROCEDIMENTO_AGRICOLA_EXCLUIR: {
    id: 'PROCEDIMENTO_AGRICOLA_EXCLUIR',
    descricao: 'Módulo Geral - Procedimento Agrícola - Excluiu Registro',
  },
  PROCEDIMENTO_AGRICOLA_CRIAR: {
    id: 'PROCEDIMENTO_AGRICOLA_CRIAR',
    descricao: 'Módulo Geral - Procedimento Agrícola - Criou Registro',
  },
  CLIENTE_NOVO: {
    id: 'CLIENTE_NOVO',
    descricao: 'Módulo Geral - Cadastro Cliente - Acessou Página de Criação',
  },
  CLIENTE_CRIAR: {
    id: 'CLIENTE_CRIAR',
    descricao: 'Módulo Geral - Cadastro Cliente - Criou Registro',
  },
  CLIENTE_EDITAR: {
    id: 'CLIENTE_EDITAR',
    descricao: 'Módulo Geral - Cadastro Cliente - Editou Registro',
  },
  CLIENTE_EXCLUIR: {
    id: 'CLIENTE_EXCLUIR',
    descricao: 'Módulo Geral - Cadastro Cliente - Excluiu Registro',
  },
  CLIENTE_ATUALIZAR: {
    id: 'CLIENTE_ATUALIZAR',
    descricao: 'Módulo Geral - Cadastro Cliente - Atualizou Filtros',
  },
  FORNECEDOR_NOVO: {
    id: 'FORNECEDOR_NOVO',
    descricao: 'Módulo Geral - Fornecedor - Acessou Página de Criação',
  },
  FORNECEDOR_CRIAR: {
    id: 'FORNECEDOR_CRIAR',
    descricao: 'Módulo Geral - Cadastro Fornecedor - Criou Registro',
  },
  FORNECEDOR_EDITAR: {
    id: 'FORNECEDOR_EDITAR',
    descricao: 'Módulo Geral - Cadastro Fornecedor - Editou Registro',
  },
  FORNECEDOR_EXCLUIR: {
    id: 'FORNECEDOR_EXCLUIR',
    descricao: 'Módulo Geral - Cadastro Fornecedor - Excluiu Registro',
  },
  FORNECEDOR_FILTRAR: {
    id: 'FORNECEDOR_FILTRAR',
    descricao: 'Módulo Geral - Cadastro Fornecedor - Filtrou registros',
  },
  // TRANSPORTADORA
  TRANSPORTADORA_NOVO: {
    id: 'TRANSPORTADORA_NOVO',
    descricao:
      'Módulo Geral - Cadastro Transportadora - Acessou Página de Criação',
  },
  TRANSPORTADORA_CRIAR: {
    id: 'TRANSPORTADORA_CRIAR',
    descricao: 'Módulo Geral - Cadastro Transportadora - Criou Registro',
  },
  TRANSPORTADORA_EDITAR: {
    id: 'TRANSPORTADORA_EDITAR',
    descricao: 'Módulo Geral - Cadastro Transportadora - Editou Registro',
  },
  TRANSPORTADORA_EXCLUIR: {
    id: 'TRANSPORTADORA_EXCLUIR',
    descricao: 'Módulo Geral - Cadastro Transportadora - Excluiu Registro',
  },
  // FUNCIONARIO
  FUNCIONAROIO_NOVO: {
    id: 'FUNCIONAROIO_NOVO',
    descricao:
      'Módulo Geral - Cadastro Funcionário - Acessou Página de Criação',
  },
  FUNCIONAROIO_CRIAR: {
    id: 'FUNCIONAROIO_CRIAR',
    descricao: 'Módulo Geral - Cadastro Funcionário - Criou Registro',
  },
  FUNCIONAROIO_EDITAR: {
    id: 'FUNCIONAROIO_EDITAR',
    descricao: 'Módulo Geral - Cadastro Funcionário - Editou Registro',
  },
  FUNCIONAROIO_EXCLUIR: {
    id: 'FUNCIONAROIO_EXCLUIR',
    descricao: 'Módulo Geral - Cadastro Funcionário - Excluiu Registro',
  },
  // MOTORISTA
  MOTORISTA_NOVO: {
    id: 'MOTORISTA_NOVO',
    descricao: 'Módulo Geral - Cadastro Motorista - Acessou Página de Criação',
  },
  MOTORISTA_CRIAR: {
    id: 'MOTORISTA_CRIAR',
    descricao: 'Módulo Geral - Cadastro Motorista - Criou Registro',
  },
  MOTORISTA_EDITAR: {
    id: 'MOTORISTA_EDITAR',
    descricao: 'Módulo Geral - Cadastro Motorista - Editou Registro',
  },
  MOTORISTA_EXCLUIR: {
    id: 'MOTORISTA_EXCLUIR',
    descricao: 'Módulo Geral - Cadastro Motorista - Excluiu Registro',
  },
  // CARGO - FUNCIONÁRIO
  FUNCIONARIO_CARGO_NOVO: {
    id: 'CARGO_FUNCIONARIO_NOVO',
    descricao: 'Módulo Geral - Cadastro de Cargo s- Acessou Página de Criação',
  },
  FUNCIONARIO_CARGO_CRIAR: {
    id: 'CARGO_FUNCIONARIO_CRIAR',
    descricao: 'Módulo Geral - Cadastro de Cargo - Criou Registro',
  },
  FUNCIONARIO_CARGO_EDITAR: {
    id: 'CARGO_FUNCIONARIO_EDITAR',
    descricao: 'Módulo Geral - Cadastro de Cargo - Editou Registro',
  },
  FUNCIONARIO_CARGO_EXCLUIR: {
    id: 'CARGO_FUNCIONARIO_EXCLUIR',
    descricao: 'Módulo Geral - Cadastro de Cargo - Excluiu Registro',
  },
  // CONVERSÃO DE UNIDADES
  CONVERSAO_UNIDADE_NOVO: {
    id: 'CONVERSAO_UNIDADE_NOVO',
    descricao:
      'Módulo Geral - Cadastro de Conversões de Unidades de Medida - Acessou Página de Criação',
  },
  CONVERSAO_UNIDADE_CRIAR: {
    id: 'CONVERSAO_UNIDADE_CRIAR',
    descricao:
      'Módulo Geral - Cadastro de Conversões de Unidades de Medida - Criou Registro',
  },
  CONVERSAO_UNIDADE_EDITAR: {
    id: 'CONVERSAO_UNIDADE_EDITAR',
    descricao:
      'Módulo Geral - Cadastro de Conversões de Unidades de Medida - Editou Registro',
  },
  CONVERSAO_UNIDADE_EXCLUIR: {
    id: 'CONVERSAO_UNIDADE_EXCLUIR',
    descricao:
      'Módulo Geral - Cadastro de Conversões de Unidades de Medida - Excluiu Registro',
  },
  // UNIDADE DE MEDIDA
  UNIDADE_MEDIDA_NOVO: {
    id: 'UNIDADE_MEDIDA_NOVO',
    descricao:
      'Módulo Geral - Cadastro de Unidades de Medida - Acessou Página de Criação',
  },
  UNIDADE_MEDIDA_CRIAR: {
    id: 'UNIDADE_MEDIDA_CRIAR',
    descricao: 'Módulo Geral - Cadastro de Unidades de Medida - Criou Registro',
  },
  UNIDADE_MEDIDA_EDITAR: {
    id: 'UNIDADE_MEDIDA_EDITAR',
    descricao:
      'Módulo Geral - Cadastro de Unidades de Medida - Editou Registro',
  },
  UNIDADE_MEDIDA_EXCLUIR: {
    id: 'UNIDADE_MEDIDA_EXCLUIR',
    descricao:
      'Módulo Geral - Cadastro de Unidades de Medida - Excluiu Registro',
  },

  // DESPESA DIRETA
  DESPESA_DIRETA_NOVO: {
    id: 'DESPESA_DIRETA_NOVO',
    descricao:
      'Módulo Geral - Cadastro de Despesa Direta - Acessou Página de Criação',
  },
  DESPESA_DIRETA_CRIAR: {
    id: 'DESPESA_DIRETA_CRIAR',
    descricao: 'Módulo Geral - Cadastro de Despesa Direta - Criou Registro',
  },
  DESPESA_DIRETA_EDITAR: {
    id: 'DESPESA_DIRETA_EDITAR',
    descricao: 'Módulo Geral - Cadastro de Despesa Direta - Editou Registro',
  },
  DESPESA_DIRETA_EXCLUIR: {
    id: 'DESPESA_DIRETA_EXCLUIR',
    descricao: 'Módulo Geral - Cadastro de Despesa Direta - Excluiu Registro',
  },
  // Estádio Fenológico
  ESTAGIO_APLICACAO_NOVO: {
    id: 'ESTAGIO_APLICACAO_NOVO',
    descricao:
      'Módulo Geral - Cadastro de Estádio Fenológico - Acessou Página de Criação',
  },
  ESTAGIO_APLICACAO_CRIAR: {
    id: 'ESTAGIO_APLICACAO_CRIAR',
    descricao:
      'Módulo Geral - Cadastro de Estádio Fenológico - Criou Registro',
  },
  ESTAGIO_APLICACAO_EDITAR: {
    id: 'ESTAGIO_APLICACAO_EDITAR',
    descricao:
      'Módulo Geral - Cadastro de Estádio Fenológico - Editou Registro',
  },
  ESTAGIO_APLICACAO_EXCLUIR: {
    id: 'ESTAGIO_APLICACAO_EXCLUIR',
    descricao:
      'Módulo Geral - Cadastro de Estádio Fenológico - Excluiu Registro',
  },
  // IDENTIFICADORES
  IDENTIFICADOR_NOVO: {
    id: 'IDENTIFICADOR_NOVO',
    descricao:
      'Módulo Geral - Cadastro de Identificadores - Acessou Página de Criação',
  },
  IDENTIFICADOR_CRIAR: {
    id: 'IDENTIFICADOR_CRIAR',
    descricao: 'Módulo Geral - Cadastro de Identificadores - Criou Registro',
  },
  IDENTIFICADOR_EDITAR: {
    id: 'IDENTIFICADOR_EDITAR',
    descricao: 'Módulo Geral - Cadastro de Identificadores - Editou Registro',
  },
  IDENTIFICADOR_EXCLUIR: {
    id: 'IDENTIFICADOR_EXCLUIR',
    descricao: 'Módulo Geral - Cadastro de Identificadores - Excluiu Registro',
  },
  // VEÍCULO DE TRANSPORTE
  VEICULO_TRANSPORTE_NOVO: {
    id: 'VEICULO_TRANSPORTE_NOVO',
    descricao:
      'Módulo Geral - Cadastro de Veículo de Transporte - Acessou Página de Criação',
  },
  VEICULO_TRANSPORTE_CRIAR: {
    id: 'VEICULO_TRANSPORTE_CRIAR',
    descricao:
      'Módulo Geral - Cadastro de Veículo de Transporte - Criou Registro',
  },
  VEICULO_TRANSPORTE_EDITAR: {
    id: 'VEICULO_TRANSPORTE_EDITAR',
    descricao:
      'Módulo Geral - Cadastro de Veículo de Transporte - Editou Registro',
  },
  VEICULO_TRANSPORTE_EXCLUIR: {
    id: 'VEICULO_TRANSPORTE_EXCLUIR',
    descricao:
      'Módulo Geral - Cadastro de Veículo de Transporte - Excluiu Registro',
  },
  // PLANEJAMENTO DA SAFRA
  PLANEJAMENTO_SAFRA_NOVO: {
    id: 'PLANEJAMENTO_SAFRA_NOVO',
    descricao:
      'Módulo Agricultura - Planejamento da Safra - Acessou Página de Criação',
  },
  PLANEJAMENTO_SAFRA_CRIAR: {
    id: 'PLANEJAMENTO_SAFRA_CRIAR',
    descricao: 'Módulo Agricultura - Planejamento - Criou Registro',
  },
  PLANEJAMENTO_SAFRA_EDITAR: {
    id: 'PLANEJAMENTO_SAFRA_EDITAR',
    descricao: 'Módulo Agricultura - Planejamento - Editou Registro',
  },
  PLANEJAMENTO_SAFRA_EXCLUIR: {
    id: 'PLANEJAMENTO_SAFRA_EXCLUIR',
    descricao: 'Módulo Agricultura - Planejamento - Excluiu Registro',
  },
  PLANEJAMENTO_SAFRA_FILTRAR: {
    id: 'PLANEJAMENTO_SAFRA_FILTRAR',
    descricao: 'Módulo Agricultura - Planejamento - Atualizou Filtros',
  },
  PLANEJAMENTO_SAFRA_REGISTRAR_REALIZACAO: {
    id: 'PLANEJAMENTO_SAFRA_REGISTRAR_REALIZACAO',
    descricao: 'Módulo Agricultura - Planejamento - Registrou Realização',
  },
  PLANEJAMENTO_SAFRA_VISUALIZAR_PLANEJAMENTO: {
    id: 'PLANEJAMENTO_SAFRA_VISUALIZAR_PLANEJAMENTO',
    descricao: 'Módulo Agricultura - Planejamento - Visualizou Planejamento',
  },
  PLANEJAMENTO_SAFRA_DUPLICAR: {
    id: 'PLANEJAMENTO_SAFRA_DUPLICAR',
    descricao: 'Módulo Agricultura - Planejamento - Duplicou Planejamento',
  },
  PLANEJAMENTO_SAFRA_IMPRIMIR_RELATORIO_PROCEDIMENTO: {
    id: 'PLANEJAMENTO_SAFRA_IMPRIMIR_RELATORIO_PROCEDIMENTO',
    descricao:
      'Módulo Agricultura - Planejamento - Gerou Relatório Do Procedimento',
  },
  PLANEJAMENTO_SAFRA_IMPRIMIR_RELATORIO_PROCEDIMENTO_SEM_CUSTO: {
    id: 'PLANEJAMENTO_SAFRA_IMPRIMIR_RELATORIO_PROCEDIMENTO_SEM_CUSTO',
    descricao:
      'Módulo Agricultura - Planejamento - Gerou Relatório Do Procedimento Sem Custo',
  },
  PLANEJAMENTO_SAFRA_IMPRIMIR_RESUMIDO: {
    id: 'PLANEJAMENTO_SAFRA_IMPRIMIR_RESUMIDO',
    descricao: 'Módulo Agricultura - Planejamento - Gerou Relatório Resumido',
  },
  PLANEJAMENTO_SAFRA_IMPRIMIR_RESUMIDO_SEM_CUSTO: {
    id: 'PLANEJAMENTO_SAFRA_IMPRIMIR_RESUMIDO_SEM_CUSTO',
    descricao:
      'Módulo Agricultura - Planejamento - Gerou Relatório Resumido Sem Custo',
  },
  PLANEJAMENTO_SAFRA_IMPRIMIR_DETALHADO: {
    id: 'PLANEJAMENTO_SAFRA_IMPRIMIR_DETALHADO',
    descricao: 'Módulo Agricultura - Planejamento - Gerou Relatório Detalhado',
  },
  PLANEJAMENTO_SAFRA_IMPRIMIR_DETALHADO_SEM_CUSTO: {
    id: 'PLANEJAMENTO_SAFRA_IMPRIMIR_DETALHADO_SEM_CUSTO',
    descricao:
      'Módulo Agricultura - Planejamento - Gerou Relatório Detalhado Sem Custo',
  },
  // EXECUÇÃO DAS ATIVIDADES AGRICOLAS
  EXECUCAO_ATIVIDADE_NOVO: {
    id: 'EXECUCAO_ATIVIDADE_NOVO',
    descricao: 'Módulo Agricultura - Execução - Clicou em Novo Procedimento',
  },
  EXECUCAO_ATIVIDADE_CUSTO_DIRETO: {
    id: 'EXECUCAO_ATIVIDADE_CUSTO_DIRETO',
    descricao: 'Módulo Agricultura - Execução - Clicou em Novo Custo Direto',
  },
  EXECUCAO_ATIVIDADE_CUSTO_DIRETO_CRIAR: {
    id: 'EXECUCAO_ATIVIDADE_CUSTO_DIRETO_CRIAR',
    descricao: 'Módulo Agricultura - Execução - Criou Um Novo Custo Direto',
  },
  EXECUCAO_ATIVIDADE_CUSTO_DIRETO_EDITAR: {
    id: 'EXECUCAO_ATIVIDADE_CUSTO_DIRETO_EDITAR',
    descricao: 'Módulo Agricultura - Execução - Editou Um Novo Custo Direto',
  },
  EXECUCAO_ATIVIDADE_CUSTO_DIRETO_EXCLUIR: {
    id: 'EXECUCAO_ATIVIDADE_CUSTO_DIRETO_EXCLUIR',
    descricao: 'Módulo Agricultura - Execução - Excluiu Um Novo Custo Direto',
  },
  EXECUCAO_ATIVIDADE_REALIZAR_PLANEJAMENTO: {
    id: 'EXECUCAO_ATIVIDADE_REALIZAR_PLANEJAMENTO',
    descricao:
      'Módulo Agricultura - Execução - Clicou em Realizar Planejamento',
  },
  EXECUCAO_ATIVIDADE_VER_PLANEJAMENTO: {
    id: 'EXECUCAO_ATIVIDADE_VER_PLANEJAMENTO',
    descricao: 'Módulo Agricultura - Planejamento - Clicou em Ver Planejamento',
  },
  EXECUCAO_ATIVIDADE_REGISTRAR_PLANEJAMENTO: {
    id: 'EXECUCAO_ATIVIDADE_REGISTRAR_PLANEJAMENTO',
    descricao:
      'Módulo Agricultura - Execução - Clicou em Registrar Planejamento',
  },
  EXECUCAO_ATIVIDADE_CRIAR: {
    id: 'EXECUCAO_ATIVIDADE_CRIAR',
    descricao: 'Módulo Agricultura - Execução - Criou Novo Procedimento',
  },
  EXECUCAO_ATIVIDADE_EDITAR: {
    id: 'EXECUCAO_ATIVIDADE_EDITAR',
    descricao: 'Módulo Agricultura - Execução - Editou Procedimento',
  },
  EXECUCAO_ATIVIDADE_EXCLUIR: {
    id: 'EXECUCAO_ATIVIDADE_EXCLUIR',
    descricao: 'Módulo Agricultura - Execução - Excluiu Procedimento',
  },
  EXECUCAO_ATIVIDADE_FILTRAR: {
    id: 'EXECUCAO_ATIVIDADE_FILTRAR',
    descricao: 'Módulo Agricultura - Execução - Filtrou os dados',
  },
  EXECUCAO_ATIVIDADE_VISUALIZAR: {
    id: 'EXECUCAO_ATIVIDADE_VISUALIZAR',
    descricao: 'Módulo Agricultura - Execução - Visualizou execução',
  },
  EXECUCAO_ATIVIDADE_IMPRIMIR_RELATORIO_PROCEDIMENTO: {
    id: 'EXECUCAO_ATIVIDADE_IMPRIMIR_RELATORIO_PROCEDIMENTO',
    descricao:
      'Módulo Agricultura - Execução - Gerou Relatório Do Procedimento',
  },
  EXECUCAO_ATIVIDADE_IMPRIMIR_RELATORIO_PROCEDIMENTO_SEM_CUSTO: {
    id: 'EXECUCAO_ATIVIDADE_IMPRIMIR_RELATORIO_PROCEDIMENTO_SEM_CUSTO',
    descricao:
      'Módulo Agricultura - Execução - Gerou Relatório Do Procedimento Sem Custo',
  },
  EXECUCAO_ATIVIDADE_IMPRIMIR_RELATORIO_RESUMIDO: {
    id: 'EXECUCAO_ATIVIDADE_IMPRIMIR_RELATORIO_RESUMIDO',
    descricao: 'Módulo Agricultura - Execução - Gerou Relatório Resumido',
  },

  EXECUCAO_ATIVIDADE_IMPRIMIR_RELATORIO_RESUMIDO_SEM_CUSTO: {
    id: 'EXECUCAO_ATIVIDADE_IMPRIMIR_RELATORIO_RESUMIDO_SEM_CUSTO',
    descricao:
      'Módulo Agricultura - Execução - Gerou Relatório Resumido Sem Custo',
  },

  EXECUCAO_ATIVIDADE_IMPRIMIR_RELATORIO_DETALHADO: {
    id: 'EXECUCAO_ATIVIDADE_IMPRIMIR_RELATORIO_DETALHADO',
    descricao: 'Módulo Agricultura - Execução - Gerou Relatório Detalhado',
  },

  EXECUCAO_ATIVIDADE_IMPRIMIR_RELATORIO_DETALHADO_SEM_CUSTO: {
    id: 'EXECUCAO_ATIVIDADE_IMPRIMIR_RELATORIO_DETALHADO_SEM_CUSTO',
    descricao:
      'Módulo Agricultura - Execução - Gerou Relatório Detalhado Sem Custo',
  },
  // COLHEITA
  COLHEITA_NOVO: {
    id: 'COLHEITA_NOVO',
    descricao:
      'Módulo Agricultura - Colheita - Acessou Página de Nova Colheita',
  },
  COLHEITA_CRIAR: {
    id: 'COLHEITA_CRIAR',
    descricao: 'Módulo Agricultura - Colheita - Criou Registro de Colheita',
  },
  COLHEITA_EDITAR: {
    id: 'COLHEITA_EDITAR',
    descricao: 'Módulo Agricultura - Colheita - Editou Registro de Colheita',
  },
  COLHEITA_EXCLUIR: {
    id: 'COLHEITA_EXCLUIR',
    descricao: 'Módulo Agricultura - Colheita - Excluiu Registro de Colheita',
  },
  COLHEITA_FILTRAR: {
    id: 'COLHEITA_FILTRAR',
    descricao: 'Módulo Agricultura - Colheita - Atualizou Listagem',
  },
  COLHEITA_VISUALIZAR: {
    id: 'COLHEITA_VISUALIZAR',
    descricao: 'Módulo Agricultura - Colheita - Visualizou colheita',
  },
  COLHEITA_IMPRIMIR: {
    id: 'COLHEITA_IMPRIMIR',
    descricao: 'Módulo Agricultura - Colheita - Imprimiu Relatório de Colheita',
  },
  COLHEITA_EXPORTAR_EXCEL: {
    id: 'COLHEITA_EXPORTAR_EXCEL',
    descricao:
      'Módulo Agricultura - Colheita - Exportou Excel Relatório de Colheita',
  },
  // VENDA DE PRODUÇÃO AGRICOLA
  VENDA_PROD_AGRICOLA_NOVO: {
    id: 'VENDA_PROD_AGRICOLA_NOVO',
    descricao:
      'Módulo Agricultura - Venda de Produção Agrícola - Acessou Página de Criação',
  },
  VENDA_PROD_AGRICOLA_CRIAR: {
    id: 'VENDA_PROD_AGRICOLA_CRIAR',
    descricao:
      'Módulo Agricultura - Venda de Produção Agrícola - Criou Registro',
  },
  VENDA_PROD_AGRICOLA_EDITAR: {
    id: 'VENDA_PROD_AGRICOLA_EDITAR',
    descricao:
      'Módulo Agricultura - Venda de Produção Agrícola - Editou Registro',
  },
  VENDA_PROD_AGRICOLA_EXCLUIR: {
    id: 'VENDA_PROD_AGRICOLA_EXCLUIR',
    descricao:
      'Módulo Agricultura - Venda de Produção Agrícola - Excluiu Registro',
  },
  VENDA_PROD_AGRICOLA_FILTRAR_LISTAGEM: {
    id: 'VENDA_PROD_AGRICOLA_FILTRAR_LISTAGEM',
    descricao:
      'Módulo Agricultura - Venda de Produção Agrícola - Filtrou registros',
  },
  VENDA_PROD_AGRICOLA_IMPRIMIR: {
    id: 'VENDA_PROD_AGRICOLA_IMPRIMIR',
    descricao:
      'Módulo Agricultura - Venda de Produção Agrícola - Imprimiu Relatório',
  },
  // PLUVIÔMETRO DIGITAL - REGISTROS CLIMÁTICOS
  PLUVIOMETRO_NOVO: {
    id: 'PLUVIOMETRO_NOVO',
    descricao: 'Módulo Geral - Pluviômetro Digital - Acessou Página de Criação',
  },
  PLUVIOMETRO_CRIAR: {
    id: 'PLUVIOMETRO_CRIAR',
    descricao: 'Módulo Geral - Pluviômetro Digital - Criou Registro Climático',
  },
  PLUVIOMETRO_EDITAR: {
    id: 'PLUVIOMETRO_EDITAR',
    descricao: 'Módulo Geral - Pluviômetro Digital - Editou Registro Climático',
  },
  PLUVIOMETRO_EXCLUIR: {
    id: 'PLUVIOMETRO_EXCLUIR',
    descricao:
      'Módulo Geral - Pluviômetro Digital - Excluiu Registro Climático',
  },
  // ABASTECIMENTO
  ABASTECIMENTO_NOVO: {
    id: 'ABASTECIMENTO_NOVO',
    descricao: 'Patrimônio - Abastecimento - Clicou em Novo Abastecimento',
  },
  ABASTECIMENTO_CRIAR: {
    id: 'ABASTECIMENTO_CRIAR',
    descricao:
      'Patrimônio - Abastecimento - Criou novo registro de abastecimento',
  },
  ABASTECIMENTO_EDITAR: {
    id: 'ABASTECIMENTO_EDITAR',
    descricao: 'Patrimônio - Abastecimento - Editou registro de abastecimento',
  },
  ABASTECIMENTO_EXCLUIR: {
    id: 'ABASTECIMENTO_EXCLUIR',
    descricao: 'Patrimônio - Abastecimento - Excluiu registro de abastecimento',
  },
  ABASTECIMENTO_FILTRAR: {
    id: 'ABASTECIMENTO_FILTRAR',
    descricao: 'Patrimônio - Abastecimento - Atualizou listagem de registros',
  },
  // MANUTENÇÃO DE PATRIMÔNIO
  MANUTENCAO_NOVO: {
    id: 'MANUTENCAO_NOVO',
    descricao: 'Patrimônio - Manutenção - Clicou em Nova Manutenção',
  },
  MANUTENCAO_CRIAR: {
    id: 'MANUTENCAO_CRIAR',
    descricao: 'Patrimônio - Manutenção - Criou novo registro de manutenção',
  },
  MANUTENCAO_EDITAR: {
    id: 'MANUTENCAO_EDITAR',
    descricao: 'Patrimônio - Manutenção - Editou registro de manutenção',
  },
  MANUTENCAO_EXCLUIR: {
    id: 'MANUTENCAO_EXCLUIR',
    descricao: 'Patrimônio - Manutenção - Excluiu registro de manutenção',
  },
  MANUTENCAO_FILTRAR: {
    id: 'MANUTENCAO_FILTRAR',
    descricao: 'Patrimônio - Manutenção - Filtrou registros',
  },
  // CADASTRO DE PATRIMÔNIO
  CADASTRO_PATRIMONIO_NOVO: {
    id: 'CADASTRO_PATRIMONIO_NOVO',
    descricao: 'Patrimônio - Cadastro - Clicou em Novo Patrimônio',
  },
  CADASTRO_PATRIMONIO_CRIAR: {
    id: 'CADASTRO_PATRIMONIO_CRIAR',
    descricao: 'Patrimônio - Cadastro - Criou novo patrimônio',
  },
  CADASTRO_PATRIMONIO_EDITAR: {
    id: 'CADASTRO_PATRIMONIO_EDITAR',
    descricao: 'Patrimônio - Cadastro - Editou patrimônio',
  },
  CADASTRO_PATRIMONIO_EXCLUIR: {
    id: 'CADASTRO_PATRIMONIO_EXCLUIR',
    descricao: 'Patrimônio - Cadastro - Excluiu patrimônio',
  },
  // IMPLANTAÇÃO RÁPIDA DE ESTOQUE
  ESTOQUE_IMPLANTACAO_NOVO: {
    id: 'ESTOQUE_IMPLANTACAO_NOVO',
    descricao: 'Estoque - Implantação Rápida - Clicou em Novo',
  },
  ESTOQUE_IMPLANTACAO_CRIAR: {
    id: 'ESTOQUE_IMPLANTACAO_CRIAR',
    descricao: 'Estoque - Implantação Rápida - Criou nova entrada de estoque',
  },
  ESTOQUE_IMPLANTACAO_EDITAR: {
    id: 'ESTOQUE_IMPLANTACAO_EDITAR',
    descricao: 'Estoque - Implantação Rápida - Editou entrada de estoque',
  },
  ESTOQUE_IMPLANTACAO_EXCLUIR: {
    id: 'ESTOQUE_IMPLANTACAO_EXCLUIR',
    descricao: 'Estoque - Implantação Rápida - Excluiu entrada de estoque',
  },
  ESTOQUE_IMPLANTACAO_FILTRAR: {
    id: 'ESTOQUE_IMPLANTACAO_FILTRAR',
    descricao: 'Estoque - Implantação Rápida - Clicou em Atualizar com filtros',
  },
  ESTOQUE_FILTRAR: {
    id: ' ESTOQUE_FILTRAR',
    descricao: 'Estoque - Implantação Rápida - Filtrou registros',
  },
  // ESTOQUE - BAIXA MANUAL
  ESTOQUE_BAIXA_MANUAL_NOVO: {
    id: 'ESTOQUE_BAIXA_MANUAL_NOVO',
    descricao: 'Estoque - Baixa Manual - Clicou em Novo',
  },
  ESTOQUE_BAIXA_MANUAL_CRIAR: {
    id: 'ESTOQUE_BAIXA_MANUAL_CRIAR',
    descricao: 'Estoque - Baixa Manual - Criou nova baixa de estoque',
  },
  ESTOQUE_BAIXA_MANUAL_EDITAR: {
    id: 'ESTOQUE_BAIXA_MANUAL_EDITAR',
    descricao: 'Estoque - Baixa Manual - Editou baixa de estoque',
  },
  ESTOQUE_BAIXA_MANUAL_EXCLUIR: {
    id: 'ESTOQUE_BAIXA_MANUAL_EXCLUIR',
    descricao: 'Estoque - Baixa Manual - Excluiu baixa de estoque',
  },
  // ESTOQUE - TRANSFERÊNCIA
  TRANSFERENCIA_ESTOQUE_NOVO: {
    id: 'TRANSFERENCIA_ESTOQUE_NOVO',
    descricao: 'Estoque - Transferência - Clicou em Novo',
  },
  TRANSFERENCIA_ESTOQUE_CRIAR: {
    id: 'TRANSFERENCIA_ESTOQUE_CRIAR',
    descricao: 'Estoque - Transferência - Criou nova transferência de Estoque',
  },
  TRANSFERENCIA_ESTOQUE_EDITAR: {
    id: 'TRANSFERENCIA_ESTOQUE_EDITAR',
    descricao: 'Estoque - Transferência - Editou transferência de Estoque',
  },
  TRANSFERENCIA_ESTOQUE_EXCLUIR: {
    id: 'TRANSFERENCIA_ESTOQUE_EXCLUIR',
    descricao: 'Estoque - Transferência - Excluiu transferência de Estoque',
  },
  TRANSFERENCIA_ESTOQUE_FILTRAR: {
    id: ' TRANSFERENCIA_ESTOQUE_FILTRAR',
    descricao: 'Estoque - Transferência - Atualizou listagem de registros',
  },
  // ESTOQUE - RELATÓRIO ESTOQUE ATUAL
  ESTOQUE_ATUAL_FILTRAR: {
    id: 'ESTOQUE_ATUAL_FILTRAR',
    descricao: 'Estoque - Relatório Estoque Atual - Clicou em Atualizar',
  },
  ESTOQUE_ATUAL_VISUALIZAR_MOVIMENTACOES: {
    id: 'ESTOQUE_ATUAL_VISUALIZAR_MOVIMENTACOES',
    descricao:
      'Estoque - Relatório Estoque Atual - Clicou em Ver Movimentações',
  },
  ESTOQUE_ATUAL_IMPRIMIR: {
    id: 'ESTOQUE_ATUAL_IMPRIMIR',
    descricao: 'Estoque - Relatório Estoque Atual - Clicou em Imprimir',
  },
  ESTOQUE_ATUAL_EXPORTAR_EXCEL: {
    id: 'ESTOQUE_ATUAL_EXPORTAR_EXCEL',
    descricao: 'Estoque - Relatório Estoque Atual - Exportou Excel Relatório de Estoque Atual',
  },
  // ESTOQUE - RELATÓRIO ESTOQUE POR PERÍODO
  ESTOQUE_POR_PERIODO_FILTRAR: {
    id: 'ESTOQUE_POR_PERIODO_FILTRAR',
    descricao: 'Estoque - Relatório Estoque Por Período - Clicou em Atualizar',
  },
  ESTOQUE_POR_PERIODO_IMPRIMIR: {
    id: 'ESTOQUE_POR_PERIODO_IMPRIMIR',
    descricao: 'Estoque - Relatório Estoque Por Período - Clicou em Imprimir',
  },
  // ESTOQUE - REPOSIÇÃO DE ESTOQUE MÍNIMO
  ESTOQUE_REPOSICAO_FILTRAR: {
    id: 'ESTOQUE_REPOSICAO_FILTRAR',
    descricao: 'Estoque - Reposição de Estoque Mínimo - Clicou em Atualizar',
  },
  ESTOQUE_REPOSICAO_IMPRIMIR: {
    id: 'ESTOQUE_REPOSICAO_IMPRIMIR',
    descricao: 'Estoque - Reposição de Estoque Mínimo - Clicou em Imprimir',
  },
  // ESTOQUE - LOCAL DE ESTOQUE
  LOCAL_ESTOQUE_NOVO: {
    id: 'LOCAL_ESTOQUE_NOVO',
    descricao:
      'Estoque - Local de Estoque - Clicou em Novo para cadastrar local',
  },
  LOCAL_ESTOQUE_CRIAR: {
    id: 'LOCAL_ESTOQUE_CRIAR',
    descricao: 'Estoque - Local de Estoque - Criou um novo local de estoque',
  },
  LOCAL_ESTOQUE_EDITAR: {
    id: 'LOCAL_ESTOQUE_EDITAR',
    descricao: 'Estoque - Local de Estoque - Clicou em Editar local',
  },
  LOCAL_ESTOQUE_EXCLUIR: {
    id: 'LOCAL_ESTOQUE_EXCLUIR',
    descricao: 'Estoque - Local de Estoque - Clicou em Excluir local',
  },
  // IMPLANTAÇÃO DE ESTOQUE - PRODUÇÃO AGRICOLA
  IMPLANTACAO_ESTOQUE_AGRICOLA_NOVO: {
    id: 'IMPLANTACAO_ESTOQUE_AGRICOLA_NOVO',
    descricao:
      'Estoque - Implantação de Estoque - Produção Agrícola - Acessou Página de Criação',
  },
  IMPLANTACAO_ESTOQUE_AGRICOLA_CRIAR: {
    id: 'IMPLANTACAO_ESTOQUE_AGRICOLA_CRIAR',
    descricao:
      'Estoque - Implantação de Estoque - Produção Agrícola - Criou Registro',
  },
  IMPLANTACAO_ESTOQUE_AGRICOLA_EDITAR: {
    id: 'IMPLANTACAO_ESTOQUE_AGRICOLA_EDITAR',
    descricao:
      'Estoque - Implantação de Estoque - Produção Agrícola - Editou Registro',
  },
  IMPLANTACAO_ESTOQUE_AGRICOLA_EXCLUIR: {
    id: 'IMPLANTACAO_ESTOQUE_AGRICOLA_EXCLUIR',
    descricao:
      'Estoque - Implantação de Estoque - Produção Agrícola - Excluiu Registro',
  },
  // BAIXA MANUAL DE ESTOQUE - PRODUÇÃO AGRICOLA
  BAIXA_MANUAL_ESTOQUE_AGRICOLA_NOVO: {
    id: 'BAIXA_MANUAL_ESTOQUE_AGRICOLA_NOVO',
    descricao:
      'Estoque - Baixa Manual de Estoque - Produção Agrícola - Acessou Página de Criação',
  },
  BAIXA_MANUAL_ESTOQUE_AGRICOLA_CRIAR: {
    id: 'BAIXA_MANUAL_ESTOQUE_AGRICOLA_CRIAR',
    descricao:
      'Estoque - Baixa Manual de Estoque - Produção Agrícola - Criou Registro',
  },
  BAIXA_MANUAL_ESTOQUE_AGRICOLA_EDITAR: {
    id: 'BAIXA_MANUAL_ESTOQUE_AGRICOLA_EDITAR',
    descricao:
      'Estoque - Baixa Manual de Estoque - Produção Agrícola - Editou Registro',
  },
  BAIXA_MANUAL_ESTOQUE_AGRICOLA_EXCLUIR: {
    id: 'BAIXA_MANUAL_ESTOQUE_AGRICOLA_EXCLUIR',
    descricao:
      'Estoque - Baixa Manual de Estoque - Produção Agrícola - Excluiu Registro',
  },
  BAIXA_MANUAL_ESTOQUE_AGRICOLA_FILTRAR: {
    id: 'BAIXA_MANUAL_ESTOQUE_AGRICOLA_FILTRAR',
    descricao:
      'Estoque - Baixa Manual de Estoque - Produção Agrícola - Filtrou Registros',
  },
  // TRANSFERÊNCIA DE ESTOQUE - PRODUÇÃO AGRICOLA
  TRANSFERENCIA_ESTOQUE_PRODUCAO_AGRICOLA_NOVO: {
    id: 'TRANSFERENCIA_ESTOQUE_PRODUCAO_AGRICOLA_NOVO',
    descricao:
      'Estoque - Transferência de Estoque - Produção Agrícola - Acessou Página de Criação',
  },
  TRANSFERENCIA_ESTOQUE_PRODUCAO_AGRICOLA_CRIAR: {
    id: 'TRANSFERENCIA_ESTOQUE_PRODUCAO_AGRICOLA_CRIAR',
    descricao:
      'Estoque - Transferência de Estoque - Produção Agrícola - Criou Registro',
  },
  TRANSFERENCIA_ESTOQUE_PRODUCAO_AGRICOLA_EDITAR: {
    id: 'TRANSFERENCIA_ESTOQUE_PRODUCAO_AGRICOLA_EDITAR',
    descricao:
      'Estoque - Transferência de Estoque - Produção Agrícola - Editou Registro',
  },
  TRANSFERENCIA_ESTOQUE_PRODUCAO_AGRICOLA_EXCLUIR: {
    id: 'TRANSFERENCIA_ESTOQUE_PRODUCAO_AGRICOLA_EXCLUIR',
    descricao:
      'Estoque - Transferência de Estoque - Produção Agrícola - Excluiu Registro',
  },
  // RELATÓRIO - ESTOQUE PRODUÇÃO AGRICOLA
  RELATORIO_ESTOQUE_AGRICOLA_FILTRAR: {
    id: 'RELATORIO_ESTOQUE_AGRICOLA_FILTRAR',
    descricao:
      'Agricultura - Relatório de Estoque - Produção Agrícola - Filtrou dados',
  },
  RELATORIO_ESTOQUE_AGRICOLA_IMPRIMIR: {
    id: 'RELATORIO_ESTOQUE_AGRICOLA_IMPRIMIR',
    descricao:
      'Agricultura - Relatório de Estoque - Produção Agrícola - Clicou em Imprimir',
  },
  // ENTRADA DE NOTA FISCAL
  ENTRADA_NF_NOVA: {
    id: 'ENTRADA_NF_NOVA',
    descricao: 'Financeiro - Entrada de Nota Fiscal - Clicou em Nova Entrada',
  },
  ENTRADA_NF_IMPORTAR_XML: {
    id: 'ENTRADA_NF_IMPORTAR_XML',
    descricao:
      'Financeiro - Entrada de Nota Fiscal - Clicou em Importar XML NFe',
  },
  ENTRADA_NF_MONITORAMENTO_COMPRAR: {
    id: 'ENTRADA_NF_MONITORAMENTO_COMPRAR',
    descricao:
      'Financeiro - Entrada de Nota Fiscal - Clicou em Monitoramento NFe - SEFAZ',
  },
  ENTRADA_NF_CRIAR: {
    id: 'ENTRADA_NF_ENTRADA_NF_CRIAR',
    descricao: 'Financeiro - Entrada de Nota Fiscal - Criou Registro',
  },
  ENTRADA_NF_EDITAR: {
    id: 'ENTRADA_NF_EDITAR',
    descricao: 'Financeiro - Entrada de Nota Fiscal - Editou Registro',
  },
  ENTRADA_NF_EXCLUIR: {
    id: 'ENTRADA_NF_EXCLUIR',
    descricao: 'Financeiro - Entrada de Nota Fiscal - Excluiu Registro',
  },
  ENTRADA_NF_FILTRAR: {
    id: 'ENTRADA_NF_FILTRAR',
    descricao: 'Financeiro - Entrada de Nota Fiscal - Filtrou registros',
  },
  ENTRADA_NF_IMPRIMIR: {
    id: 'ENTRADA_NF_IMPRIMIR',
    descricao: 'Financeiro - Entrada de Nota Fiscal - Clicou em Imprimir',
  },
  // CONTA A PAGAR
  CONTA_PAGAR_NOVO: {
    id: 'CONTA_PAGAR_NOVO',
    descricao:
      'Financeiro - Conta a Pagar - Acessou Página de Criação de Despesa',
  },
  CONTA_PAGAR_CRIAR: {
    id: 'CONTA_PAGAR_CRIAR',
    descricao: 'Financeiro - Conta a Pagar - Criou Registro de Despesa',
  },
  CONTA_PAGAR_EDITAR: {
    id: 'CONTA_PAGAR_EDITAR',
    descricao: 'Financeiro - Conta a Pagar - Editou Registro de Despesa',
  },
  CONTA_PAGAR_EXCLUIR: {
    id: 'CONTA_PAGAR_EXCLUIR',
    descricao: 'Financeiro - Conta a Pagar - Excluiu Registro de Despesa',
  },
  CONTA_PAGAR_FILTRO: {
    id: 'CONTA_PAGAR_FILTRO',
    descricao: 'Financeiro - Conta a Pagar - Aplicou Filtros de Pesquisa',
  },
  CONTA_PAGAR_IMPRIMIR: {
    id: 'CONTA_PAGAR_IMPRIMIR',
    descricao: 'Financeiro - Conta a Pagar - Gerou Impressão da Listagem',
  },
  CONTA_PAGAR_IMPORTAR_NFE: {
    id: 'CONTA_PAGAR_IMPORTAR_NFE',
    descricao: 'Financeiro - Conta a Pagar - Importou Entrada de Nota Fiscal',
  },
  CONTA_PAGAR_RECORRENTE: {
    id: 'CONTA_PAGAR_RECORRENTE',
    descricao:
      'Financeiro - Conta a Pagar - Acessou Página de Despesas Recorrentes',
  },
  // CONTA A PAGAR RECORRENTE
  CONTA_PAGAR_RECORRENTE: {
    id: 'CONTA_PAGAR_RECORRENTE',
    descricao:
      'Financeiro - Conta a Pagar Recorrente - Acessou Página de Conta à Pagar Recorrente',
  },
  CONTA_PAGAR_RECORRENTE_NOVO: {
    id: 'CONTA_PAGAR_RECORRENTE_NOVO',
    descricao:
      'Financeiro - Conta a Pagar Recorrente - Acessou Página de Criação de Recorrência',
  },
  CONTA_PAGAR_RECORRENTE_CRIAR: {
    id: 'CONTA_PAGAR_RECORRENTE_CRIAR',
    descricao:
      'Financeiro - Conta a Pagar Recorrente - Criou Registro de Recorrência',
  },
  CONTA_PAGAR_RECORRENTE_EDITAR: {
    id: 'CONTA_PAGAR_RECORRENTE_EDITAR',
    descricao:
      'Financeiro - Conta a Pagar Recorrente - Editou Registro de Recorrência',
  },
  CONTA_PAGAR_RECORRENTE_EXCLUIR: {
    id: 'CONTA_PAGAR_RECORRENTE_EXCLUIR',
    descricao:
      'Financeiro - Conta a Pagar Recorrente - Excluiu Registro de Recorrência',
  },
  CONTA_PAGAR_RECORRENTE_FILTRO: {
    id: 'CONTA_PAGAR_RECORRENTE_FILTRO',
    descricao:
      'Financeiro - Conta a Pagar Recorrente - Aplicou Filtros de Pesquisa',
  },
  CONTA_PAGAR_RECORRENTE_ATUALIZAR: {
    id: 'CONTA_PAGAR_RECORRENTE_ATUALIZAR',
    descricao:
      'Financeiro - Conta a Pagar Recorrente - Atualizou a Listagem de Registros',
  },
  CONTA_PAGAR_RECORRENTE_GERAR_DESPESA: {
    id: 'CONTA_PAGAR_RECORRENTE_GERAR_DESPESA',
    descricao:
      'Financeiro - Conta a Pagar Recorrente - Gerou Despesa Manualmente',
  },
  // CONTA A RECEBER
  CONTA_RECEBER_RECEITA_FAZENDA_NOVO: {
    id: 'CONTA_RECEBER_RECEITA_FAZENDA_NOVO',
    descricao:
      'Financeiro - Conta a Receber - Acessou Página de Nova Receita Fazenda',
  },
  CONTA_RECEBER_RECEITA_SAFRA_NOVO: {
    id: 'CONTA_RECEBER_RECEITA_SAFRA_NOVO',
    descricao:
      'Financeiro - Conta a Receber - Acessou Página de Nova Receita Safra',
  },
  CONTA_RECEBER_CRIAR: {
    id: 'CONTA_RECEBER_CRIAR',
    descricao: 'Financeiro - Conta a Receber - Criou Receita Manualmente',
  },
  CONTA_RECEBER_EDITAR: {
    id: 'CONTA_RECEBER_EDITAR',
    descricao: 'Financeiro - Conta a Receber - Editou Receita Manualmente',
  },
  CONTA_RECEBER_EXCLUIR: {
    id: 'CONTA_RECEBER_EXCLUIR',
    descricao: 'Financeiro - Conta a Receber - Excluiu Receita',
  },
  CONTA_RECEBER_FILTRO: {
    id: 'CONTA_RECEBER_FILTRO',
    descricao: 'Financeiro - Conta a Receber - Aplicou Filtros de Pesquisa',
  },
  CONTA_RECEBER_FILTRAR: {
    id: 'CONTA_RECEBER_FILTRAR',
    descricao:
      'Financeiro - Conta a Receber - Atualizou a Listagem de Registros',
  },
  CONTA_RECEBER_IMPRIMIR: {
    id: 'CONTA_RECEBER_IMPRIMIR',
    descricao: 'Financeiro - Conta a Receber - Imprimiu Listagem de Receitas',
  },
  // Fluxo de caixa
  FLUXO_CAIXA_FILTRAR: {
    id: 'FLUXO_CAIXA_FILTRAR',
    descricao:
      'Financeiro - Fluxo de Caixa - Atualizou a Listagem de Registros',
  },
  // MOVIMENTAÇÕES BANCÁRIAS
  MOVIMENTACOES_BANCARIAS_NOVO: {
    id: 'MOVIMENTACOES_BANCARIAS_NOVO',
    descricao: 'Financeiro - Movimentações Bancárias - Acessou Página de Novo Lançamento',
  },
  MOVIMENTACOES_BANCARIAS_CONCILIACAO_BANCARIA: {
    id: 'MOVIMENTACOES_BANCARIAS_CONCILIACAO_BANCARIA',
    descricao: 'Financeiro - Movimentações Bancárias - Acessou Página de Conciliação Bancária',
  },
  MOVIMENTACOES_BANCARIAS_CRIAR: {
    id: 'MOVIMENTACOES_BANCARIAS_CRIAR',
    descricao: 'Financeiro - Movimentações Bancárias - Criou nova movimentação',
  },
  MOVIMENTACOES_BANCARIAS_EDITAR: {
    id: 'MOVIMENTACOES_BANCARIAS_EDITAR',
    descricao: 'Financeiro - Movimentações Bancárias - Editou movimentação',
  },
  MOVIMENTACOES_BANCARIAS_EXCLUIR: {
    id: 'MOVIMENTACOES_BANCARIAS_EXCLUIR',
    descricao: 'Financeiro - Movimentações Bancárias - Excluiu movimentação',
  },
  MOVIMENTACOES_BANCARIAS_FILTRAR: {
    id: 'MOVIMENTACOES_BANCARIAS_FILTRAR',
    descricao: 'Financeiro - Movimentações Bancárias - Atualizou listagem',
  },
  MOVIMENTACOES_BANCARIAS_IMPRIMIR: {
    id: 'MOVIMENTACOES_BANCARIAS_IMPRIMIR',
    descricao:
      'Financeiro - Movimentações Bancárias - Imprimiu listagem de movimentações',
  },
  // MOVIMENTAÇÃO DE CAIXA
  MOVIMENTACAO_CAIXA_FILTRAR: {
    id: 'MOVIMENTACAO_CAIXA_FILTRAR',
    descricao:
      'Módulo Financeiro - Movimentações de Caixa - Filtrou registros',
  },
  MOVIMENTACAO_CAIXA_NOVO: {
    id: 'MOVIMENTACAO_CAIXA_NOVO',
    descricao:
      'Módulo Financeiro - Movimentações de Caixa - Acessou Página de Criação',
  },
  MOVIMENTACAO_CAIXA_CRIAR: {
    id: 'MOVIMENTACAO_CAIXA_CRIAR',
    descricao: 'Módulo Financeiro - Movimentações de Caixa - Criou Registro',
  },
  MOVIMENTACAO_CAIXA_EDITAR: {
    id: 'MOVIMENTACAO_CAIXA_EDITAR',
    descricao: 'Módulo Financeiro - Movimentações de Caixa - Editou Registro',
  },
  MOVIMENTACAO_CAIXA_EXCLUIR: {
    id: 'MOVIMENTACAO_CAIXA_EXCLUIR',
    descricao: 'Módulo Financeiro - Movimentações de Caixa - Excluiu Registro',
  },
  MOVIMENTACAO_CAIXA_IMPRIMIR: {
    id: 'MOVIMENTACAO_CAIXA_IMPRIMIR',
    descricao:
      'Módulo Financeiro - Movimentações de Caixa - Imprimiu Relatório',
  },
  // TRANSFERÊNCIA BANCO/CAIXA
  TRANSFERENCIA_BANCO_CAIXA_NOVO: {
    id: 'TRANSFERENCIA_BANCO_CAIXA_NOVO',
    descricao:
      'Módulo Financeiro - Transferência Banco/Caixa - Acessou Página de Criação',
  },
  TRANSFERENCIA_BANCO_CAIXA_CRIAR: {
    id: 'TRANSFERENCIA_BANCO_CAIXA_CRIAR',
    descricao: 'Módulo Financeiro - Transferência Banco/Caixa - Criou Registro',
  },
  TRANSFERENCIA_BANCO_CAIXA_EDITAR: {
    id: 'TRANSFERENCIA_BANCO_CAIXA_EDITAR',
    descricao:
      'Módulo Financeiro - Transferência Banco/Caixa - Editou Registro',
  },
  TRANSFERENCIA_BANCO_CAIXA_EXCLUIR: {
    id: 'TRANSFERENCIA_BANCO_CAIXA_EXCLUIR',
    descricao:
      'Módulo Financeiro - Transferência Banco/Caixa - Excluiu Registro',
  },
  TRANSFERENCIA_BANCO_CAIXA_FILTRAR: {
    id: 'TRANSFERENCIA_BANCO_CAIXA_FILTRAR',
    descricao:
      'Módulo Financeiro - Transferência Banco/Caixa - Atualizou os Resultados',
  },
  // CADASTRO DE CONTA BANCO
  CADASTRO_CONTA_BANCO_NOVO: {
    id: 'CADASTRO_CONTA_BANCO_NOVO',
    descricao:
      'Módulo Financeiro - Cadastro de Conta Banco - Acessou Página de Criação',
  },
  CADASTRO_CONTA_BANCO_CRIAR: {
    id: 'CADASTRO_CONTA_BANCO_CRIAR',
    descricao: 'Módulo Financeiro - Cadastro de Conta Banco - Criou Registro',
  },
  CADASTRO_CONTA_BANCO_EDITAR: {
    id: 'CADASTRO_CONTA_BANCO_EDITAR',
    descricao: 'Módulo Financeiro - Cadastro de Conta Banco - Editou Registro',
  },
  CADASTRO_CONTA_BANCO_EXCLUIR: {
    id: 'CADASTRO_CONTA_BANCO_EXCLUIR',
    descricao: 'Módulo Financeiro - Cadastro de Conta Banco - Excluiu Registro',
  },
  CADASTRO_CONTA_BANCO_FILTRAR: {
    id: 'CADASTRO_CONTA_BANCO_FILTRAR',
    descricao:
      'Módulo Financeiro - Cadastro de Conta Banco - Atualizou Resultados',
  },
  // CADASTRO DE CONTA CAIXA
  CADASTRO_CONTA_CAIXA_NOVO: {
    id: 'CADASTRO_CONTA_CAIXA_NOVO',
    descricao:
      'Módulo Financeiro - Cadastro de Conta Caixa - Acessou Página de Criação',
  },
  CADASTRO_CONTA_CAIXA_CRIAR: {
    id: 'CADASTRO_CONTA_CAIXA_CRIAR',
    descricao: 'Módulo Financeiro - Cadastro de Conta Caixa - Criou Registro',
  },
  CADASTRO_CONTA_CAIXA_EDITAR: {
    id: 'CADASTRO_CONTA_CAIXA_EDITAR',
    descricao: 'Módulo Financeiro - Cadastro de Conta Caixa - Editou Registro',
  },
  CADASTRO_CONTA_CAIXA_EXCLUIR: {
    id: 'CADASTRO_CONTA_CAIXA_EXCLUIR',
    descricao: 'Módulo Financeiro - Cadastro de Conta Caixa - Excluiu Registro',
  },
  CADASTRO_CONTA_CAIXA_FILTRAR: {
    id: 'CADASTRO_CONTA_CAIXA_FILTRAR',
    descricao:
      'Módulo Financeiro - Cadastro de Conta Caixa - Atualizou os Resultados',
  },
  // PLANO DE CONTAS GERENCIAL
  PLANO_CONTAS_GERENCIAL_NOVO: {
    id: 'PLANO_CONTAS_GERENCIAL_NOVO',
    descricao:
      'Módulo Financeiro - Plano de Contas Gerencial - Acessou Página de Criação',
  },
  PLANO_CONTAS_GERENCIAL_CRIAR: {
    id: 'PLANO_CONTAS_GERENCIAL_CRIAR',
    descricao: 'Módulo Financeiro - Plano de Contas Gerencial - Criou Registro',
  },
  PLANO_CONTAS_GERENCIAL_EDITAR: {
    id: 'PLANO_CONTAS_GERENCIAL_EDITAR',
    descricao:
      'Módulo Financeiro - Plano de Contas Gerencial - Editou Registro',
  },
  PLANO_CONTAS_GERENCIAL_EXCLUIR: {
    id: 'PLANO_CONTAS_GERENCIAL_EXCLUIR',
    descricao:
      'Módulo Financeiro - Plano de Contas Gerencial - Excluiu Registro',
  },
  PLANO_CONTAS_GERENCIAL_IMPRIMIR: {
    id: 'PLANO_CONTAS_GERENCIAL_IMPRIMIR',
    descricao:
      'Módulo Financeiro - Plano de Contas Gerencial - Clicou em Imprimir',
  },
  // CENTRO DE CUSTO
  CENTRO_CUSTO_NOVO: {
    id: 'CENTRO_CUSTO_NOVO',
    descricao:
      'Módulo Financeiro - Centro de Custo - Acessou Página de Criação',
  },
  CENTRO_CUSTO_CRIAR: {
    id: 'CENTRO_CUSTO_CRIAR',
    descricao: 'Módulo Financeiro - Centro de Custo - Criou Registro',
  },
  CENTRO_CUSTO_EDITAR: {
    id: 'CENTRO_CUSTO_EDITAR',
    descricao: 'Módulo Financeiro - Centro de Custo - Editou Registro',
  },
  CENTRO_CUSTO_EXCLUIR: {
    id: 'CENTRO_CUSTO_EXCLUIR',
    descricao: 'Módulo Financeiro - Centro de Custo - Excluiu Registro',
  },
  // MONITORAMENTO NFE - SEFAZ
  NFE_MONITORAMENTO_FILTRAR: {
    id: 'NFE_MONITORAMENTO_FILTRAR',
    descricao: 'Módulo Fiscal - Monitoramento NFe - Clicou em FILTRAR',
  },
  NFE_MONITORAMENTO_DOWNLOAD_ARQUIVOS: {
    id: 'NFE_MONITORAMENTO_DOWNLOAD_ARQUIVOS',
    descricao:
      'Módulo Fiscal - Monitoramento NFe - Clicou em Download Arquivos NFe',
  },
  // EMISSÃO NFE DE PRODUTOR
  NFE_PRODUTOR_NOVA_NFE: {
    id: 'NFE_PRODUTOR_NOVA_NFE',
    descricao:
      'Módulo Fiscal - Emissão NFe de Produtor - Acessou Página de Criação',
  },
  NFE_PRODUTOR_CRIAR: {
    id: 'NFE_PRODUTOR_CRIAR',
    descricao: 'Módulo Fiscal - Emissão NFe de Produtor - Criou Registro',
  },
  NFE_PRODUTOR_EDITAR: {
    id: 'NFE_PRODUTOR_EDITAR',
    descricao: 'Módulo Fiscal - Emissão NFe de Produtor - Editou Registro',
  },
  NFE_PRODUTOR_EXCLUIR: {
    id: 'NFE_PRODUTOR_EXCLUIR',
    descricao: 'Módulo Fiscal - Emissão NFe de Produtor - Excluiu Registro',
  },
  NFE_PRODUTOR_DOWNLOAD: {
    id: 'NFE_PRODUTOR_DOWNLOAD',
    descricao:
      'Módulo Fiscal - Emissão NFe de Produtor - Clicou em Download Arquivos NFe',
  },
  NFE_PRODUTOR_FILTRAR: {
    id: 'NFE_PRODUTOR_FILTRAR',
    descricao: 'Módulo Fiscal - Emissão NFe de Produtor - Clicou em Atualizar',
  },
  NFE_PRODUTOR_FILTRO_COMPLETO: {
    id: 'NFE_PRODUTOR_FILTRO_COMPLETO',
    descricao:
      'Módulo Fiscal - Emissão NFe de Produtor - Clicou em Filtro Completo',
  },
  // INSCRIÇÃO FISCAL - PRODUTOR RURAL
  INSCRICAO_FISCAL_NOVO: {
    id: 'INSCRICAO_FISCAL_NOVO',
    descricao: 'Módulo Fiscal - Inscrição Fiscal - Acessou Página de Criação',
  },
  INSCRICAO_FISCAL_CRIAR: {
    id: 'NFE_PRODUTOR_CRIAR',
    descricao: 'Módulo Fiscal - Inscrição Fiscal - Criou Registro',
  },
  INSCRICAO_FISCAL_EDITAR: {
    id: 'INSCRICAO_FISCAL_EDITAR',
    descricao: 'Módulo Fiscal - Inscrição Fiscal - Editou Registro',
  },
  INSCRICAO_FISCAL_EXCLUIR: {
    id: 'INSCRICAO_FISCAL_EXCLUIR',
    descricao: 'Módulo Fiscal - Inscrição Fiscal - Excluiu Registro',
  },
  // CERTIFICADO DIGITAL
  CERTIFICADO_DIGITAL_NOVO: {
    id: 'CERTIFICADO_DIGITAL_NOVO',
    descricao:
      'Módulo Fiscal - Certificado Digital - Acessou Página de Criação',
  },
  CERTIFICADO_DIGITAL_CRIAR: {
    id: 'CERTIFICADO_DIGITAL_CRIAR',
    descricao: 'Módulo Fiscal - Certificado Digital - Criou Registro',
  },
  CERTIFICADO_DIGITAL_EDITAR: {
    id: 'CERTIFICADO_DIGITAL_EDITAR',
    descricao: 'Módulo Fiscal - Certificado Digital - Editou Registro',
  },
  CERTIFICADO_DIGITAL_EXCLUIR: {
    id: 'CERTIFICADO_DIGITAL_EXCLUIR',
    descricao: 'Módulo Fiscal - Certificado Digital - Excluiu Registro',
  },
  // FUNRURAL
  FUNRURAL_ATUALIZAR: {
    id: 'FUNRURAL_ATUALIZAR',
    descricao: 'Módulo Fiscal - FUNRURAL - Clicou no botão Atualizar',
  },
  // MENSAGEM FISCAL
  MENSAGEM_FISCAL_NOVO: {
    id: 'MENSAGEM_FISCAL_NOVO',
    descricao: 'Módulo Fiscal - Mensagem Fiscal - Acessou Página de Criação',
  },
  MENSAGEM_FISCAL_CRIAR: {
    id: 'MENSAGEM_FISCAL_CRIAR',
    descricao: 'Módulo Fiscal - Mensagem Fiscal - Criou Registro',
  },
  MENSAGEM_FISCAL_EDITAR: {
    id: 'MENSAGEM_FISCAL_EDITAR',
    descricao: 'Módulo Fiscal - Mensagem Fiscal - Editou Registro',
  },
  MENSAGEM_FISCAL_EXCLUIR: {
    id: 'MENSAGEM_FISCAL_EXCLUIR',
    descricao: 'Módulo Fiscal - Mensagem Fiscal - Excluiu Registro',
  },
  // NATUREZA DE OPERAÇÃO
  NATUREZA_OPERACAO_NOVO: {
    id: 'NATUREZA_OPERACAO_NOVO',
    descricao:
      'Módulo Fiscal - Natureza de Operação - Acessou Página de Criação',
  },
  NATUREZA_OPERACAO_CRIAR: {
    id: 'NATUREZA_OPERACAO_CRIAR',
    descricao: 'Módulo Fiscal - Natureza de Operação - Criou Registro',
  },
  NATUREZA_OPERACAO_EDITAR: {
    id: 'NATUREZA_OPERACAO_EDITAR',
    descricao: 'Módulo Fiscal - Natureza de Operação - Editou Registro',
  },
  NATUREZA_OPERACAO_EXCLUIR: {
    id: 'NATUREZA_OPERACAO_EXCLUIR',
    descricao: 'Módulo Fiscal - Natureza de Operação - Excluiu Registro',
  },
  // TABELA TRIBUTÁRIA
  TABELA_TRIBUTARIA_NOVO: {
    id: 'TABELA_TRIBUTARIA_NOVO',
    descricao: 'Módulo Fiscal - Tabela Tributária - Acessou Página de Criação',
  },
  TABELA_TRIBUTARIA_CRIAR: {
    id: 'TABELA_TRIBUTARIA_CRIAR',
    descricao: 'Módulo Fiscal - Tabela Tributária - Criou Registro',
  },
  TABELA_TRIBUTARIA_EDITAR: {
    id: 'TABELA_TRIBUTARIA_EDITAR',
    descricao: 'Módulo Fiscal - Tabela Tributária - Editou Registro',
  },
  TABELA_TRIBUTARIA_EXCLUIR: {
    id: 'TABELA_TRIBUTARIA_EXCLUIR',
    descricao: 'Módulo Fiscal - Tabela Tributária - Excluiu Registro',
  },
  CONTA_CARTAO_NOVO: {
    id: 'CONTA_CARTAO_NOVO',
    descricao: 'Módulo Financeiro - Cadastro Conta Cartão - Acessou a página de criação'
  },
  CONTA_CHEQUE_PRE_DATADO_NOVO: {
    id: 'CONTA_CHEQUE_PRE_DATADO_NOVO',
    descricao: 'Módulo Financeiro - Cadastro Cheque Pré-datato - Acessou a página de criação'
  },
  FILE_STORAGE: {
    id: 'FILE_STORAGE',
    descricao: 'Módulo File Storage - Anexou Arquivo'
  },
  FISCAL_CERTIFICADO_DIGITAL: {
    id: 'FISCAL_CERTIFICADO_DIGITAL',
    descricao: 'Módulo Fiscal - Certificado Digital - Ativou Monitoramento NFe'
  },
  FISCAL_MONITORAMENTO_NFE: {
    id: 'FISCAL_MONITORAMENTO_NFE',
    descricao: 'Módulo Fiscal - Monitoramento - Importou NFe'
  },
  // PRAGAS E DOENÇAS - CADASTRO
  PRAGA_DOENCA_NOVO: {
    id: 'PRAGA_DOENCA_NOVO',
    descricao: 'Módulo Geral - Pragas e Doenças - Acessou Página de Criação',
  },
  PRAGA_DOENCA_CRIAR: {
    id: 'PRAGA_DOENCA_CRIAR',
    descricao: 'Módulo Geral - Pragas e Doenças - Criou Registro',
  },
  PRAGA_DOENCA_EDITAR: {
    id: 'PRAGA_DOENCA_EDITAR',
    descricao: 'Módulo Geral - Pragas e Doenças - Editou Registro',
  },
  PRAGA_DOENCA_EXCLUIR: {
    id: 'PRAGA_DOENCA_EXCLUIR',
    descricao: 'Módulo Geral - Pragas e Doenças - Excluiu Registro',
  },
  // CONTROLE DE PRAGAS E DOENÇAS
  CONTROLE_PRAGA_DOENCA_NOVO: {
    id: 'CONTROLE_PRAGA_DOENCA_NOVO',
    descricao: 'Módulo Agricultura - Controle de Pragas e Doenças - Acessou Página de Criação',
  },
  CONTROLE_PRAGA_DOENCA_CRIAR: {
    id: 'CONTROLE_PRAGA_DOENCA_CRIAR',
    descricao: 'Módulo Agricultura - Controle de Pragas e Doenças - Criou Registro',
  },
  CONTROLE_PRAGA_DOENCA_EDITAR: {
    id: 'CONTROLE_PRAGA_DOENCA_EDITAR',
    descricao: 'Módulo Agricultura - Controle de Pragas e Doenças - Editou Registro',
  },
  CONTROLE_PRAGA_DOENCA_EXCLUIR: {
    id: 'CONTROLE_PRAGA_DOENCA_EXCLUIR',
    descricao: 'Módulo Agricultura - Controle de Pragas e Doenças - Excluiu Registro',
  },
  // ALERTA MANUTENCAO
  PATRIMONIO_MANUTENCAO_ALERTA_NOVO: {
    id: 'PATRIMONIO_MANUTENCAO_ALERTA_NOVO',
    descricao: 'Módulo Patrimônio - Alerta Manutenção - Acessou Página de Criação',
  },
   PATRIMONIO_MANUTENCAO_ALERTA_CRIAR: {
    id: 'PATRIMONIO_MANUTENCAO_ALERTA_CRIAR',
    descricao: 'Módulo Patrimônio - Alerta Manutenção - Criou Registro',
  },
   PATRIMONIO_MANUTENCAO_ALERTA_EDITAR: {
    id: 'PATRIMONIO_MANUTENCAO_ALERTA_EDITAR',
    descricao: 'Módulo Patrimônio - Alerta Manutenção - Editou Registro',
  },
   PATRIMONIO_MANUTENCAO_ALERTA_EXCLUIR: {
    id: 'PATRIMONIO_MANUTENCAO_ALERTA_EXCLUIR',
    descricao: 'Módulo Patrimônio - Alerta Manutenção - Excluiu Registro',
  }
};
